import React from 'react';
import { Metric } from '../../../api/adminDashboard';
import DashboardCard from './DashboardCard';
import MetricHeader from './MetricHeader';

interface MetricCardProps {
    title: string;
    metric: Metric;
    className?: string;
}

const MetricCard: React.FC<MetricCardProps> = ({ title, metric, className }) => (
    <DashboardCard title={title} className={className}>
        <div className="ad-metric-card-body">
            <MetricHeader displayValue={metric.displayValue} deltaPct={metric.deltaPct} />
        </div>
    </DashboardCard>
);

export default MetricCard;
